/**
 * @vuepress
 * ---
 * title: provider transformer
 */

import Transformer from '../transformer'
import zoneTransformer from '@/transformers/catalogs/zones'
import { auroraUserFullName } from '@/transformers/utils'

class providerTransformer extends Transformer {
  /**
   * @author José Luis Ruiz
   */

  static fetch({ id, slug, commercial_name: commercialName = '', curp, does_bill: doesBill, provider_number: providerNumber, rfc, is_active: isActive, main_family: mainFamily = { slug: '', codename: '' }, services_zone: servicesZone = [], ...provider }) {
    return {
      'fullName': provider.name ? auroraUserFullName(provider) : '',
      'mainFamily': mainFamily.codename,
      'familySlug': mainFamily.slug,
      'servicesZone': zoneTransformer.fetchCollection(servicesZone),
      doesBill,
      providerNumber,
      commercialName,
      curp,
      slug,
      id
    }
  }
}
export default providerTransformer
